export class UserCount {
  subscriptionLevels?: string = "";
  createdStartDate?: Date = null;
  createdEndDate?: Date = null;
  isEnabled = true;
}
